import Logo from "../assets/images/logo.svg";
import PlayStoreBtn from "../assets/images/playstore-button.svg";
import AppStoreBtn from "../assets/images/appstore-button.svg";
import DotImage from "../assets/images/dots.svg";
import RecommendMobiles from "../assets/images/recommendMobiles-sm.webp";
import SearchCard from "../assets/images/Search-sm.webp";
import Plan from "../assets/images/Plan-sm.webp";
import Influence from "../assets/images/Influence-sm.webp";
import LogYourDives from "../assets/images/Log_your_dive-sm.webp";
import RecommendsBG from "../assets/images/recommends-bg.webp";
import ExploreTheInterfaceBg from "../assets/images/exploreInterface-bg.webp";
import EIMobile1 from "../assets/images/ei1.webp";
import EIMobile2 from "../assets/images/ei2.webp";
import EIMobile3 from "../assets/images/ei3.webp";
import EIMobile4 from "../assets/images/ei4.webp";
import ContactUsBg from "../assets/images/contact-bg.webp";
import GetInTouch from "../assets/images/getInTouch.webp";
import Location from "../assets/images/location.svg";
import Phone from "../assets/images/phone.svg";
import Email from "../assets/images/email.svg";
import InstaGram from "../assets/images/instagram.svg";
import CheckIcon from "../assets/images/check.svg";
import AttachFile from "../assets/images/attach-file.svg";
import LogoIcon from "../assets/images/logo-icon.svg";
import HeroMobiles from "../assets/images/heroMobiles-sm.webp";
import BoxImage from "../assets/images/greyBox.svg";
import SendIcon from "../assets/images/send-svgrepo-com.svg";

export const Images = {
  logo: Logo,
  playStoreBtn: PlayStoreBtn,
  appStoreBtn: AppStoreBtn,
  dotImage: DotImage,
  heroMobiles: HeroMobiles,
  boxImage: BoxImage,
  recommendsBg: RecommendsBG,
  recommendsMobiles: RecommendMobiles,
  exploreTheInterfaceBg: ExploreTheInterfaceBg,
  contactUsBg: ContactUsBg,
  getInTouch: GetInTouch,
  attachFile: AttachFile,
  logoIcon: LogoIcon,
  sendIcon: SendIcon,
};

export const Strings = {
  AboveAndBeyond: "Above and Beyond",
  heroHeading: (isMobile: boolean) =>
    isMobile
      ? ["Diving Made Social,", "Planning Made Simple"]
      : ["Diving Made Social,", "Planning Made", "Simple"],
};

export const RecommendsStaticData = {
  recommendsHeading: "DiveBuddies",
  recommendsSubHeading:
    "Your ultimate diving companion—helping you explore, prepare, and dive with confidence, wherever your underwater journey takes you.",

  cards: [
    {
      heading: "Search",
      subheading: (isMobile: boolean) =>
        isMobile
          ? "Explore top-rated dive sites worldwide with conditions, reviews, and detailed guides. Identify marine life with our database of species, habitats, images, and seasonal sightings."
          : "Search and discover top-rated dive sites around the world, complete with detailed descriptions, conditions, and user reviews. Dive deeper into your experience by exploring a comprehensive marine life database—identify species you've seen or hope to encounter, with images, habitats, and seasonal sightings.",
      image: SearchCard,
    },
    {
      heading: "Plan",
      subheading: (isMobile: boolean) =>
        isMobile
          ? "Plan unforgettable dive adventures with our trip planning feature. Schedule dives, manage trip and gear checklists, invite buddies and manage expense- all in one place."
          : "Plan unforgettable dive adventures with our trip planning feature. Schedule dives, manage trip and gear checklists, invite buddies and manage expense- all in one place.",
      image: Plan,
    },
    {
      heading: "Influence",
      subheading: (isMobile: boolean) =>
        isMobile
          ? "Influence & Share Your Dive Stories: Showcase your underwater adventures by sharing stunning photos and videos. Connect with the dive community, gain followers, and inspire others to explore the deep blue."
          : "Influence & Share Your Dive Stories: Showcase your underwater adventures by sharing stunning photos and videos. Connect with the dive community, gain followers, and inspire others to explore the deep blue.",
      image: Influence,
    },
    {
      heading: "Log Your Dives",
      subheading: (isMobile: boolean) =>
        isMobile
          ? "Log Every Dive Effortlessly and Keep a detailed record of all your dives—depth, duration, location, buddies, and notes—right in the app. Your personal dive history, always organized and accessible."
          : "Log Every Dive Effortlessly and Keep a detailed record of all your dives—depth, duration, location, buddies, and notes—right in the app. Your personal dive history, always organized and accessible.",
      image: LogYourDives,
    },
  ],
};

export const ExploreTheInterfaceStaticData = {
  heading: "Explore the Interface",
  subHeading:
    "Discover the essence of the ocean through moments we've captured above and below the surface.",
  cards: [
    {
      heading: "Search for Dive Sites",
      image: EIMobile1,
    },
    {
      heading: "Plan your next Diving Trip",
      image: EIMobile2,
    },
    {
      heading: "Share your Dive Stories",
      image: EIMobile3,
    },
    {
      heading: "Log your Dive",
      image: EIMobile4,
    },
  ],
};

export const ContactUsStaticData = {
  heading: "Contact Us",
  subheading:
    "Reach out for support, inquiries, or collaboration opportunities.",

  getInTouch: {
    heading: "Get In Touch",
    subheading: "Our doors are open — here's where you'll find us.",
    cards: [
      {
        icon: Location,
        text: "Dubai, UAE",
        link: "https://maps.app.goo.gl/J38QqBFrjzF4pAdx6", // Google Maps link
      },
      {
        icon: Phone,
        text: "+971 56 694 5796",
        link: "tel:+971 56 694 5796", // phone dial
        // text: "+91 9559227118",
        // link: "tel:+91 9559227118", // phone dial
      },
      {
        icon: Email,
        text: "hello@divebuddies.app",
        link: "mailto:hello@divebuddies.app",
      },
      {
        icon: InstaGram,
        text: "DiveBuddies/instagram",
        link: "https://www.instagram.com/divebuddies_app?igsh=MXhyM3NyZ2c2ZGprMA==", // instagram profile
      },
    ],
  },
};

export const FooterStaticData = {
  heading: "Download DiveBuddies for free",
  playStoreBtn: Images.playStoreBtn,
  appStoreBtn: Images.appStoreBtn,
  copyRight: "© Copyright DiveBuddies ",
  allRightReserved: "All rights reserved.",
  cards: [
    {
      icon: CheckIcon,
      text: "Search",
    },
    {
      icon: CheckIcon,
      text: "Plan",
    },
    {
      icon: CheckIcon,
      text: "Influence",
    },
    {
      icon: CheckIcon,
      text: "Log your dives",
    },
  ],
  footerLinks: [
    {
      heading: "Links",
      links: [
        {
          text: "Privacy Policy",
          link: "https://admin.divebuddies.app/privacy-policy",
          blank: true,
        },
        {
          text: "Terms of Use",
          link: "https://admin.divebuddies.app/term-and-conditions",
          blank: true,
        },
      ],
    },
    {
      heading: "Company",
      links: [
        {
          text: "About Us",
          link: "#about-us",
          blank: false,
        },
        {
          text: "Contact Us",
          link: "#contact-us",
          blank: false,
        },
      ],
    },
    {
      heading: "Help & Support",
      links: [
        {
          text: "Getting Started FAQ",
          link: "https://admin.divebuddies.app/faq",
          blank: true,
        },
      ],
    },
  ],
};

export const PlayStoreDownloadLink =
  "https://play.google.com/store/apps/details?id=com.divebuddies";
export const AppStoreDownloadLink =
  "https://apps.apple.com/in/app/divebuddies/id6739330868";
